<mat-sidenav-container class="min-h-screen flex flex-col bg-transparent">
  <mat-sidenav #sidenav mode="side" opened class="w-64 border-r border-r-(--mat-sys-outline-variant)">
    <app-sidenav></app-sidenav>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="flex flex-col h-screen overflow-hidden">
      <app-header (menuToggled)="sidenav.toggle()"></app-header>
      <main class="grow h-0 p-4 md:p-6 overflow-auto">
        <router-outlet></router-outlet>
      </main>
      <app-footer class="shrink-0"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
